import { CommonModule } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	inject,
	Input,
	Output,
	ViewEncapsulation,
} from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import { LinkDirective } from '@valk-nx/core/lib/directives/link/link.directive';

import { Link } from './link.interface';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	imports: [CommonModule, RouterModule, LinkDirective],
	selector: 'vp-link',
	templateUrl: './link.html',
})
export class LinkComponent {
	private readonly router = inject(Router);

	@Input() className = '';
	@Input({ required: true }) link: Link = {
		url: '',
	};
	@Input() type: 'link' | 'button' | 'link-unstyled' = 'link';
	@Input() buttonClassName = 'btn btn-primary';

	@Output() linkClick = new EventEmitter<void>();

	// routerLinkValue returns as string to avoid encoding issues
	get routerLinkValue(): string {
		const url = decodeURIComponent(this.link.url);

		// Handle relative paths
		if (url.startsWith('./') || url.startsWith('../')) {
			return url;
		}

		// Handle absolute paths starting with /
		if (url.startsWith('/')) {
			return url;
		}

		// Handle root paths (prepend /)
		return '/' + url;
	}

	setHash(hash: string): void {
		// This is a workaround for the fact that the routerLink directive does not support hashes.
		this.router.navigateByUrl(this.router.url + hash);
		/* istanbul ignore next */
		setTimeout(() => {
			window.location.reload();
		});
	}
}
